module.exports = __webpack_public_path__ + "media/images/icons/user-circle-690fd83e83b88f5ba515baa6b4d8f1bf.svg";